<template>
  <ul class="days-container no-text-selection">
    <li @click="handleInput(null)" :class="{ 'btn-primary': !selected }">
      همه
    </li>
    <li
      v-for="(state, index) in states"
      :key="index"
      @click="handleInput(state.id)"
      @dblclick="handleInput(null)"
      :class="{ 'btn-primary': selected == state.id }"
    >
      {{ state.name }}
      <i
        v-if="state.color"
        :style="
          `${state.color ? `color: #${state.color}` : ''}; font-size: 10px`
        "
        class="fas fa-circle"
      ></i>
    </li>
  </ul>
</template>
<script>
export default {
  props: {
    value: {},
    allowedStates: {
      type: Array,
      defalt: [],
    },
    type: {
      type: String,
      default: "requestdetail",
    },
  },
  data() {
    return {
      selected: this.value,
      states: [],
      selectedDate: "",
    };
  },
  mounted() {
    this.getStates();
  },
  watch: {
    value: function(_val) {
      this.selected = _val;
    },
  },
  methods: {
    getStates() {
      this.$persistClient("get", `states?type=${this.type}`).then((res) => {
        if (this.allowedStates && this.allowedStates.length > 0) {
          this.states = collect(res.data).whereIn("id", this.allowedStates);
        } else this.states = res.data;
      });
    },
    handleInput(_val) {
      this.selected = _val;
      this.$emit("input", this.selected);
    },
  },
};
</script>
<style scoped>
.days-container {
  all: unset;
  list-style: none;
  display: flex;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  flex-wrap: wrap;
  gap: 10px;
}
.days-container li {
  float: right;
  padding: 6px 16px;
  background: #14a8d90a;
  border: 1px solid #14a9d9;
  width: max-content;
}
.days-container li:hover {
  background: #696969;
  cursor: pointer;
}
li.active {
  background: olivedrab;
}
@media (prefers-color-scheme: dark) {
  .days-container li {
    float: right;
    padding: 6px 16px;
    background: #f8fafc;
  }
}
</style>
